import DateFnsUtils from '@date-io/date-fns';
import {FormControl} from '@material-ui/core';
/* eslint-disable max-lines-per-function */
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import locale from '../locale/Localization';

const useStyles = makeStyles(() => ({
  radioGroup: {flexDirection: 'row'}
}));
/**
 * EmployeeEditDialog function.
 * @param {P} props
 * @return {Function} the employee edit dialog function.
 */
export default function EmployeeEditDialog(props) {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        disableBackdropClick
        maxWidth={'xs'}
        aria-labelledby='form-dialog-title'
        open={props.open}
        onClose={props.handleClose}
      >
        <DialogTitle id='form-dialog-title'>
          {props.employee.id
            ? locale.employeeListEditDialogTitle
            : locale.employeeListAddDialogTitle}
        </DialogTitle>
        <DialogContent>
          <TextField
            value={props.employee.officialName}
            required
            disabled={props.readOnly}
            margin='dense'
            name='name'
            label={locale.name}
            type='text'
            fullWidth
            onChange={(event: Object) => {
              props.handleValueChange('officialName', event.target.value);
            }}
          />
          <TextField
            value={props.employee.firstNames}
            required
            disabled={props.readOnly}
            margin='dense'
            name='firstName'
            label={locale.firstName}
            type='text'
            fullWidth
            onChange={(event: Object) => {
              props.handleValueChange('firstNames', event.target.value);
            }}
          />
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              required
              disableToolbar
              disabled={props.readOnly}
              autoOk={true}
              variant='inline'
              fullWidth
              format={locale.datePickerFormat}
              margin='normal'
              label={locale.birthdate}
              invalidDateMessage={locale.datePickerErrorText}
              value={props.employee.birthDate}
              onChange={(date: string) => {
                if (date instanceof Date && !isNaN(date)) {
                  props.handleValueChange(
                    'birthDate',
                    moment(date).format(locale.dateFormat)
                  );
                }
              }}
            />
          </MuiPickersUtilsProvider>
          <div>
            <h5>{locale.archiveAccess}</h5>
            {props.employee.archiveAccess.map((access, key) => {
              return (
                <span key={key}>
                  <FormControl component='fieldset'>
                    <FormLabel component='legend'>
                      {access.archiveName}
                    </FormLabel>
                    <RadioGroup
                      aria-label='archive-access'
                      className={classes.radioGroup}
                      name='archive-access'
                      value={access.access}
                      onChange={(event) => {
                        props.handleAccessChange(access, event.target.value);
                      }}
                    >
                      <FormControlLabel
                        value='READ'
                        control={
                          <Radio disabled={props.readOnly} color='primary' />
                        }
                        label={locale.archiveAccessRead}
                      />
                      {key == 0 && (
                        <FormControlLabel
                          value='WRITE'
                          control={
                            <Radio disabled={props.readOnly} color='primary' />
                          }
                          label={locale.archiveAccessReadWrite}
                        />
                      )}
                    </RadioGroup>
                  </FormControl>
                </span>
              );
            })}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color='primary'
            variant='outlined'
          >
            {locale.cancelButton}
          </Button>
          {!props.readOnly && (
            <Button
              disabled={
                !(
                  props.employee.firstNames &&
                  props.employee.officialName &&
                  props.employee.birthDate
                )
              }
              onClick={() => {
                props.handleSubmit();
              }}
              color='primary'
              variant='contained'
            >
              {props.employee.id ? locale.saveButton : locale.addButton}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

EmployeeEditDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  employee: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  handleAccessChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
